<template lang="jade">
  modal.popout(
    v-bind:show.sync= "show"
    effect= "fade"
    v-bind:callback='applyChange'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-header(slot='modal-header')
      span.close(@click='show = false') &times;
      h2(slot='modal-title' v-show= "isOut") Output {{ outputData._id }}
      h2(slot='modal-title' v-else) Input {{ inputData._id }}
    .modal-body(slot='modal-body').clearfix
      .col-md-6.col-xs-6.outDevice_img.device_img(v-if='isOut')
        .col-md-12.no_pad
          //- .default_device
          //-   i.fa.fa-desktop.fa-5x
          img.img-responsive(v-bind:src='inputImgs[inputImgFocus]')
        //- swiper.output(
          direction='horizontal'
          v-bind:initial-page='outputImgFocus - 1'
          v-bind:slide-to-page='outputImgFocus - 1'
          @slide-change-end="onOutSwiperEnd"
          v-bind:modal-shown.sync="show")
          .inner__slider(v-for="($index, slide) in outImgsliders")
            img.img-height-responsive(v-bind:src='slide.url')
      .col-md-6.col-xs-6.device_img(v-else)
        .col-md-12.no_pad(v-if="inputData.type === 'HDMI'")
          h3.title Photo {{ inputImgFocus }}
          swiper.input(
            direction='horizontal'
            v-bind:initial-page='inputImgFocus - 1'
            v-bind:slide-to-page='inputImgFocus - 1'
            @slide-change-end="onInSwiperEnd"
            v-bind:modal-shown.sync="show"
            v-bind:transitioning.sync='transitioning'
          )
            .inner__slider(v-for="($index, slide) in inImgsliders")
              img.img-responsive(v-bind:src='slide.url')
        .col-md-0.no_pad.col-centered(v-if="inputData.type === 'VGA'")
          img.img-responsive.vga(v-bind:src='vgaIcon')
      .col-md-6.col-xs-6.device_config
        h3.title Name
          input.form-control(v-show= "isOut" v-model="outputData.name" maxlength='7')
          input.form-control(v-else v-model="inputData.name" maxlength='7')
        //- div(v-if="isOut && hdcpCapability.outputs.enabled.settable && isInstaller" )
        //-   h3.title HDCP
        //-   label.iosCheck
        //-     input(type="checkbox" v-model="outputData.HDCP.enabled")
        //-     i
        div(v-if="!isOut && hdcpCapability.inputs.enabled.settable && isInstaller" )
          h3.title HDCP
          label.iosCheck
            input(type="checkbox" v-model="inputData.HDCP.enabled")
            i
        h3.title(v-if="isOut") favorite
        label.favoriteCheck(v-if="isOut")
          input(type= "checkbox" v-model="isFavorite")
          i.fa.fa-heart
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(v-on:click='show = false') Cancel
      button.btn.btn-primary(v-on:click='applyChange' v-bind:disabled.sync='transitioning') Apply
</template>


<script>
  // import $ from 'jquery'
  import { modal } from 'vue-strap'
  import { call, setUserDeviceFavoritePort, photos } from 'src/Service'
  import _ from 'lodash'
  import swiper from 'src/components/Swiper.vue'

  let store = {}
  export default {
    components: {
      modal,
      swiper
    },
    props: {
      isInstaller: {
        type: Boolean
      },
      show: {
        type: Boolean,
        require: true,
        twoWay: true
      },
      inputData: {
        type: null
      },
      outputData: {
        type: null
      },
      hdcpCapability: {
        type: null
      },
      favoritePort: {
        type: null
      },
      isOut: {
        type: null
      }
    },
    data () {
      return {
        vgaIcon: photos.vga[0],
        isFavorite: false,
        inputImgs: photos.inputs,
        outputImgs: photos.outputs,
        inputImgFocus: null,
        outputImgFocus: null,
        transitioning: false
      }
    },
    computed: {
      outImgsliders () {
        let sliders = {}
        for (let i = 1; i < this.outputImgs.length; i++) {
          sliders[i] = {
            _id: i,
            url: this.outputImgs[i]
          }
        }
        // this.outputImgFocus = this.outputData.photo
        return sliders
      },
      inImgsliders () {
        let sliders = {}
        for (let i = 1; i < this.inputImgs.length; i++) {
          sliders[i] = {
            _id: i,
            url: this.inputImgs[i]
          }
        }
        this.inputImgFocus = this.inputData.photo
        return sliders
      }
    }, // close computed
    watch: {
      show (newV) {
        this.transitioning = false
        if (newV) {
          if (this.outputData) this.isFavorite = this.favoritePort === this.outputData._id
          if (!this.isOut) {
            store.inputData = _.cloneDeep(this.inputData)
            this.inputData = _.cloneDeep(this.inputData)
            this.inputImgFocus = store.inputData.photo
            console.log('inputImgFoucs', this.inputImgFocus)
          } else {
            store.inputData = _.cloneDeep(this.inputData)
            store.outputData = _.cloneDeep(this.outputData)
            this.inputData = _.cloneDeep(this.inputData)
            this.outputData = _.cloneDeep(this.outputData)
            this.inputImgFocus = store.inputData.photo
            this.outputImgFocus = store.outputData.photo
          }
        }
      }
    },
    methods: {
      alert (type, title, content) {
        this.$dispatch('alert', {
          type: type,
          title: title,
          content: content
        })
      },
      onOutSwiperEnd (currentPage) {
        this.outputImgFocus = currentPage + 1
        this.outputData.photo = currentPage + 1
      },
      onInSwiperEnd (currentPage) {
        // handle focused
        this.inputImgFocus = currentPage + 1
        this.inputData.photo = currentPage + 1
      },
      applyChange () {
        if (this.transitioning) return
        // validate empty
        if (!this.isOut && this.inputData.name.trim().length === 0 || this.isOut && this.outputData.name.trim().length === 0) {
          this.alert('danger', '', 'Port Name can not be empty')
          return
        }
        if (  // name changed
          (!this.isOut && (this.inputData.name !== store.inputData.name)) ||
          (this.isOut && (this.outputData.name !== store.outputData.name)) ||
          (!this.isOut && (this.inputData.photo !== store.inputData.photo)) ||
          (this.isOut && (this.outputData.photo !== store.outputData.photo))
        ) {
          let params = {
            [this.isOut ? 'outputs' : 'inputs']: {
              [this.isOut ? this.outputData._id : this.inputData._id]: {
                name: this.isOut ? this.outputData.name.trim() : this.inputData.name.trim(),
                photo: this.isOut ? String(this.outputImgFocus) : String(this.inputImgFocus)
              }
            }
          }
          call(this.$route.params.mac, 'dxSetPortInfo', params)
          .then(() => {
            this.$dispatch('update', this.$route.params.mac, {
              type: 'info',
              event: params
            })
            this.alert('success', '', 'Port detail modified')
          })
          .then(() => {
            this.show = false
          })
        } else {
          console.log('not changed')
          this.show = false
        }
        if (this.isOut && this.isFavorite !== (this.favoritePort === this.outputData._id)) {   // favorite type changes
          console.log('favorite changes', this.isFavorite)
          setUserDeviceFavoritePort({
            [this.$route.params.mac]: this.isFavorite ? this.outputData._id : '0'
          })
        }
      }
    }
  }
</script>
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  .popout{
    .img-responsive {
      filter: $GLOBAL_filter_for_light_monotone_img;
    }
    .img-responsive.vga {
      filter: none;
    }
    .modal-header{
      padding-top:$space_xxs;
      padding-bottom:$space_xxs;
      .close{
        margin-top: 8px;
      }
    }
    .outDevice_img{
      padding-top: 15px;
    }
    .device_img{
      img{
        margin-left: auto;
        margin-right: auto;
      }
      .moveIt{
        width: 800%;
        outline:1px solid #f00;
        min-width:800px;
      }
      .inner__slider{
        display:inline-block;
        //background-color:$base_white;
        img {
          box-sizing:border-box;
          margin-left: auto;
          margin-right: auto;
        }
        &.focused{
          border:2px solid $pri_dark;
        }
        &.sliderStyle{
          width:100%;
          @include breakpoint(iFive){
            min-width: 100px;
          }
        }
      }
      .output{
        .inner__slider{
          height: 176px;
          @include breakpoint(xxs) {
            height: 80px;
          }
        }
      }
      .input{
        .inner__slider{
          @include breakpoint(xxs){
            height: 104px;
          }
          img{
            @include breakpoint(xxs){
              max-height: 100%;
              width: auto;
            }
          }
        }
      }
    }
  }

  /* =========== favorite switch style ========*/
  .favoriteCheck{
    input {
      display:none;
    }
    i {
      display:inline-block;
      cursor:pointer;
      color: darken($BS_modal_body_bg, 14%);
      transition: all ease .2s;
    }
    :checked + i{
      color:#f00;
    };
  }
  .default_device{  // [FIXME] unused ?
    padding-top: 30px;
    margin-left: auto;
    margin-right: auto;
    color: $pri_gray;
    text-align: center;
    .fa{
      font-size: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// CardModal.vue?4e3d48c2